import type { PhotoImportOrder } from '../../utils/imageImportUtils';
import { isMobileImportDevice } from '../../utils/imageImportUtils';

interface PhotoOrderToggleProps {
  photoOrder: PhotoImportOrder;
  onPhotoOrderChange: (order: PhotoImportOrder) => void;
}

export function PhotoOrderToggle({ photoOrder, onPhotoOrderChange }: PhotoOrderToggleProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 sm:p-5 shadow-sm min-w-0">
      <p className="text-sm font-medium text-gray-900 mb-2">写真の順序</p>
      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => onPhotoOrderChange('shooting')}
          className={`px-3 py-2.5 rounded-lg border-2 text-sm font-medium transition-colors ${
            photoOrder === 'shooting'
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-200 text-gray-700 hover:border-blue-300 hover:bg-gray-50'
          }`}
        >
          古い順（撮影順）
        </button>
        <button
          type="button"
          onClick={() => onPhotoOrderChange('picker')}
          className={`px-3 py-2.5 rounded-lg border-2 text-sm font-medium transition-colors ${
            photoOrder === 'picker'
              ? 'border-blue-500 bg-blue-50 text-blue-700'
              : 'border-gray-200 text-gray-700 hover:border-blue-300 hover:bg-gray-50'
          }`}
        >
          新しい順（選択順）
        </button>
      </div>
      <p className="mt-2 text-xs text-gray-500">
        {photoOrder === 'shooting'
          ? isMobileImportDevice()
            ? 'スマートフォン向けの初期設定です。先に撮影した写真から並びます。'
            : '先に撮影・保存した写真から並びます。'
          : 'ファイル選択画面で選んだ順番のまま並びます。'}
      </p>
    </div>
  );
}
